import { render, staticRenderFns } from "./speakerInfo.vue?vue&type=template&id=0b58c42f&"
import script from "./speakerInfo.ts?vue&type=script&lang=js&"
export * from "./speakerInfo.ts?vue&type=script&lang=js&"
import style0 from "./speakerInfo.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports